import { FC } from 'react';

import { CalendarDays, MessageSquareText, Store } from 'lucide-react';

import { Button } from '../../../components/ui/Button';
import { Card, CardContent } from '../../../components/ui/Card';
import { OfferProperty, Order } from '../../../types';
import { formatLocalDateTime } from '../../../utils';
import { OrderItemsList } from '../Orders/OrderItemsList';
import { OrderReviewSummary } from '../Orders/OrderReviewSummary';

interface Props {
    order: Order;
    offerProperties: OfferProperty[];
    onReview: (order: Order) => void;
}

export const ReviewOrderCard: FC<Props> = ({
    order,
    offerProperties,
    onReview,
}) => {
    return (
        <Card
            className="overflow-hidden transition-shadow hover:shadow-md"
            data-testid={`review-order-${order.id}`}
        >
            <CardContent className="p-4 sm:p-5">
                <div className="flex flex-col gap-5 xl:flex-row xl:items-center">
                    <div className="min-w-0 flex-1 space-y-4">
                        <div className="flex flex-wrap gap-x-4 gap-y-2 text-xs text-muted-foreground">
                            <span className="font-semibold text-foreground">
                                Замовлення {order.number}
                            </span>
                            <span className="flex items-center gap-1">
                                <Store className="h-3.5 w-3.5" />
                                Продавець:
                                <a
                                    href={`/user/${order.seller.nickname}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="font-semibold text-foreground hover:underline"
                                >
                                    {order.seller.nickname}
                                </a>
                            </span>
                            <span className="flex items-center gap-1">
                                <CalendarDays className="h-3.5 w-3.5" />
                                Завершено{' '}
                                {formatLocalDateTime(order.completed_at)}
                            </span>
                        </div>

                        <OrderItemsList
                            items={order.order_items}
                            label="Куплені товари:"
                            offerProperties={offerProperties}
                        />
                    </div>

                    {order.can_review && (
                        <Button
                            type="button"
                            variant="success"
                            className="w-full shrink-0 xl:w-auto"
                            onClick={() => onReview(order)}
                        >
                            <MessageSquareText className="mr-2 h-4 w-4" />
                            Залишити відгук
                        </Button>
                    )}
                </div>

                {order.review && (
                    <OrderReviewSummary
                        review={order.review}
                        title="Ваш відгук до цього замовлення"
                    />
                )}
            </CardContent>
        </Card>
    );
};
